var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "a",
      {
        class: _vm.className,
        attrs: { href: "#" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.showModal.apply(null, arguments)
          },
        },
      },
      [_vm._v("\n    " + _vm._s(_vm.deleteText) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "modal",
        staticClass: "modal fade",
        attrs: {
          id: "confirmation",
          tabindex: "-1",
          "aria-labelledby": "exampleModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h1",
                {
                  staticClass: "modal-title fs-5",
                  attrs: { id: "confirmationLabel" },
                },
                [_vm._v(_vm._s(_vm._f("translate")(_vm.questionText)))]
              ),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn-close",
                attrs: {
                  type: "button",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body text-start" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("translate")(_vm.explanationText)) +
                  "\n          "
              ),
              _c(
                "form",
                {
                  ref: "delete-form",
                  staticStyle: { display: "none" },
                  attrs: { action: _vm.url, method: "POST" },
                },
                [
                  _c("input", {
                    attrs: { type: "hidden", name: "_token" },
                    domProps: { value: _vm.csrf },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "hidden", name: "_method", value: "DELETE" },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary btn-sm",
                  attrs: { type: "button", "data-bs-dismiss": "modal" },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("translate")(_vm.cancelText)) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger btn-sm",
                  attrs: { type: "button" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v(_vm._s(_vm._f("translate")(_vm.deleteText)))]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }